import React from 'react'
import TablaNotificaciones from '../../../components/TablaNotificaciones/TablaNotificaciones'
import { Row, Col, Select, Layout, } from "antd";
import { BreadCrumbAdmin } from '../../../components/Administrador/Breadcrumb/Breadcrumb';

const { Option } = Select;
const { Header, Content } = Layout;
const CentroNotificaciones = () => {
  const routes = [{ nombre: "Notificaciones" }, { nombre: "Centro de notificaciones" }];
  return (
    <div className="main-c6">
      <BreadCrumbAdmin routes={routes} />
      <Layout style={{ padding: '20px' }}>
        <Content className="main--formal-box">
          <Content className="">
            <Content className="">
              <Row>
                <Col span={24}>
                  <Content className="eval_pro_containt_area p-1 ">


                    <Content
                      style={{ boxShadow: "-3px 3px 18px 1px rgba(0,0,0,0.23)", borderRadius: "15px", padding: 15 }}
                    >
                      <Content className="evalpro_table_head">

                      </Content>
                      <Content className="">
                        <Content className="">
                          {/*   <Table
                                columns={columns}
                                dataSource={evaluateProjectList}
                                scroll={{ x: 'calc(590px + 50%)', y: 340 }}
                                rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                              /> */}
                          
                          <TablaNotificaciones></TablaNotificaciones>

                        </Content>
                      </Content>
                    </Content>

                  </Content>
                </Col>
              </Row>
            </Content>
          </Content>



        </Content>
        <Content className="footer-bar">{/*    <Footer /> */}</Content>
      </Layout>

    </div>
  )
}

export default CentroNotificaciones
